import { defineDirective } from '~/scripts/utils/alpine'
import { Edge, getMouseEdge } from '~/scripts/utils/mouse'
import { setCSSVariable } from '~/scripts/utils/css'

type Axis = 'x' | 'y'

function normalizeEdge(edge: Edge, axis: Axis[]): Edge {
  if (!axis.includes('x')) {
    if (edge === 'left') {
      return 'top'
    } else if (edge === 'right') {
      return 'bottom'
    }
  }
  if (!axis.includes('y')) {
    if (edge === 'top') {
      return 'left'
    } else if (edge === 'bottom') {
      return 'right'
    }
  }
  return edge
}

/**
 * x-mouse-edge directive
 * Animates .mouse-edge child element upon mouse enter/leave events
 * @example Basic usage
 * <div x-mouse-edge class="relative">
 *   <div class="mouse-edge absolute inset-0"></div>
 *   Content will animate based on mouse edge
 * </div>
 *
 * @example Only y-axis
 * <div x-mouse-edge.y>
 */
export default defineDirective((element, { modifiers }) => {
  const axis: Axis[] = []
  if (modifiers.includes('x')) {
    axis.push('x')
  }
  if (modifiers.includes('y')) {
    axis.push('y')
  }
  if (axis.length === 0) {
    axis.push('x', 'y')
  }

  element.addEventListener('mouseenter', (event) => {
    element.style.visibility = ''
    const edge = getMouseEdge(event, element)
    setCSSVariable(element, 'mouse-edge', `in-${normalizeEdge(edge, axis)}`)
  })

  element.addEventListener('mouseleave', (event) => {
    const edge = getMouseEdge(event, element)
    setCSSVariable(element, 'mouse-edge', `out-${normalizeEdge(edge, axis)}`)
  })
})
